<template>
    <el-row class="main-box flex-cloumn flex1">
        <el-col class="flex-row f-justify-center" :md="{ span: 20, offset: 2 }" :lg="{span: 14,offset:2}" :xl="{span: 10,offset:7}" >
            <div class="content-box flex-column flex-align-center">
                <span class="content-box-title">单词识别</span>
                <div class="content-box-list flex-row f-justify-between flex-wrap ">
                    <div v-for="(item, index) in sudnumlist" :key="'word_item' + index" class="content-box-item flex-column f-center"
                        :style="{ backgroundImage: 'url(' + require('@/static/word-bg' + (index + 1) + '.png') + ')' }">
                        <div>
                            {{item.wordCount}}
                        </div>
                    </div>
                </div>
                <span class="content-box-text">课程倒计时{{djtimer}}</span>
            </div>
        </el-col>
        <el-col :md="{ span: 20, offset: 4 }" :lg="{span: 7,offset:1}" :xl="{span: 5,offset:0}">
            <div class="content-box2 flex-column f-align-center">
                <el-select class="content-box2-select"   v-model="courseName" placeholder="请选择"
				@change="selectchange"
				>
                    <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.name">
                    </el-option>
                </el-select>
                <div class="content-box2-info flex-column ">
                    <div class="content-box2-info-item flex-row f-align-cnter flex-wrap">
                        <span>本次课识词</span>
                        <span>{{suddata.thisKnowWordCount?suddata.thisKnowWordCount:0}}</span>
                    </div>
                    <div class="content-box2-info-item flex-row f-align-cnter">
                        <span>剩余待复习</span>
                        <span>{{ suddata.leftToReview?suddata.leftToReview:0}}</span>
                    </div>
                    <div class="content-box2-info-item flex-row f-align-cnter">
                        <span>本课程累计识词</span>
                        <span>{{suddata.totalWordCount?suddata.totalWordCount:0}}</span>
                    </div>
					<div class="content-box2-info-item flex-row f-align-cnter">
					    <span>全课程累计识词</span>
					    <span>{{suddata.totalWordRecognition?suddata.totalWordRecognition:0}}</span>
					</div>
                </div>

                <div class="content-box2-info-btn1" @click="startfx()" >开始复习</div>
                <div class="content-box2-info-btn2" @click="continueXX()">继续学习</div>
                <div @click="backHandle" class="content-box2-info-btn3">返回</div>
            </div>
        </el-col>


	<el-dialog title="" :center="true" :visible.sync="dialogConfrimStartClass" :show-close="false">
		
		    <el-row slot="title" style="width: 100%;">
		        <el-col :xs="{ span: 22, offset: 1 }" :sm="{ span: 22, offset: 1 }" :md="{ span: 24, offset: 0 }">
		            <div class="appraise-popup-title flex-row f-justify-between f-align-center">
		                <div style="width:56px;height:56px;"></div>
		                <span class="appraise-popup-title-name">提示</span>
		                <img @click="dialogConfrimStartClass = false" src="../static/close.png" alt="">
		            </div>
		        </el-col>
		    </el-row>
		    <el-row style="width: 100%;">
		        <el-col :xs="{ span: 22, offset: 1 }" :sm="{ span: 22, offset: 1 }" :md="{ span: 24, offset: 0 }">
		            <div class="start-popup-content flex-column f-align-center">
		                <div class="start-popup-content-tipsbox flex-row f-align-center">
		                    <span>当前课程存在未完成的学习流程，单词数：<span style="color:#0AA26B;">{{jxdata.learnWordDetailVos==null?0: jxdata.learnWordDetailVos.length}}</span>个</span>
		                </div>
		                <div class="start-popup-content-line"></div>
		                <div class="start-popup-content-btnsbox flex-row f-justify-end" style="width:100%;">
		                    <div style="cursor: pointer;" @click="learnCheckoutDeleteWord">重新选择</div>
		                    <div style="cursor: pointer;" @click="startSubmit">继续学习</div>
		                </div>
		            </div>
	
		        </el-col>
		    </el-row>
		
		</el-dialog>		
    </el-row>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { Loading } from 'element-ui';
export default {
    data() {
        return {
            options: [{
            }],
			suddata:{},
			sudnumlist:[
			],
			planId:"",
			courseId:"",
			studentId:"",
			courseName:"",
			recordId:"",
			jxdata:{},
		timer: null,//
		djtimer:"00:00",
		countdown:"",
		  dialogConfrimStartClass: false,
        }
    },
	created() {
		  this.planId = decodeURIComponent(this.$route.query.planId);
		   this.courseId = decodeURIComponent(this.$route.query.courseId);
		    this.studentId = decodeURIComponent(this.$route.query.studentId);
			this.courseName = decodeURIComponent(this.$route.query.courseName);
			this.attendClassEndTime = decodeURIComponent(this.$route.query.attendClassEndTime);
		   this.getdata();
		   this.getdataCourseList();
		   this.timeFn();
	},
	beforeDestroy() {
			this.clearTimer();
	 },
	computed: {
	  ...mapState([
	      'userToken',
		   'userInfos',
	  ]),
	  ...mapGetters(["getUserToken"])
	},
    methods: {
	timeFn() {
		var timestamp = new Date().getTime();
		if(this.attendClassEndTime-timestamp<0)
		{
			this.djtimer="00:00";
			return;
		}
		this.countdown=Math.floor((this.attendClassEndTime-timestamp)/1000);
	     this.timer = setInterval(() => {
	                if (this.countdown > 0) {
	                    this.countdown--;
					this.djtimer=this.formatSecound( this.countdown);
					console.log(this.djtimer);
	                } else {
	                    clearInterval(this.timer);
	                    // 倒计时结束后需要执行的操作
	                    this.is_pause = false
	                }
	     }, 1000);
	   },
	   clearTimer () {
	       this.timer && clearInterval(this.timer)
	    },
	 formatSecound(seconds){
		 var m=seconds ;
		var hour=Math.floor(m/60) ;
		var minutest=m%60;
		if(minutest<10)
		{
			return hour+":0"+minutest;
		}
		return hour+":"+minutest;
	},
	startSubmit(){
		this.dialogConfrimStartClass=false;
		this.$router.push({
			name: "attend_class_list2",
			params:{
			courseId:this.courseId,
			recordId:this.recordId,
			countdown:this.attendClassEndTime,
			data:this.jxdata.learnWordDetailVos,
			}
		});
	},
		startfx (){
		this.$router.push({
		    path: "/attend_class_list3",
			query:{
				courseId:this.courseId,
				planId:this.planId,
				studentId:this.studentId,
			}
		});	
		},
		async continueXX(){
		let res = await this.$api.get("/web/teacher/attendClass/learnCheckout", {
		    headers: { //头部参数
		        frontUserToken: this.getUserToken
		    },
			params:{
					planId:this.planId,
					courseId:this.courseId,
			 }
		});
				if(res.code==200)
				{
					this.jxdata=res.data;
					
					if(res.data.flag==1)
					{		
						this.recordId=res.data.recordId;
						this.dialogConfrimStartClass=true;
					}else{
						this.$router.push({
							path: "/attend_class_list",
							query:{
								courseId:this.courseId,
								planId:this.planId,
								countdown:this.attendClassEndTime,
								studentId:this.studentId,
							}
						});
					}
			
				}
				else{
					this.$message({
					  type: "warning",
					  message: res.msg
					});
				}
		},
		async learnCheckoutDeleteWord(){
			this.dialogConfrimStartClass=false;
			let res = await this.$api.get("/web/teacher/attendClass/learnCheckoutDeleteWord", {
			    headers: { //头部参数
			        frontUserToken: this.getUserToken
			    },
				params:{
						planId:this.planId,
						courseId:this.courseId,
				 }
			});
				if(res.code==200)
				{
				this.$router.push({
				    path: "/attend_class_list",
					query:{
						courseId:this.courseId,
						planId:this.planId,
						studentId:this.studentId,
					}
				});
				}
				else{
						this.$message({
						  type: "warning",
						  message: res.msg
						});
					}
		},
        backHandle(){
            this.$router.back();
        },
		selectchange(data){
			console.log("!!!~~~~"+data);
			
			for(var item in this.options)
			{
				var itemdata= this.options[item];
				if(itemdata.name==data)
				{
					this.courseId=itemdata.id;
					break;
				}
			}
			this.getdata();
		},
		async getdataCourseList() {
		    let res = await this.$api.get("/web/teacher/attendClass/sudokuStudentCourseList", {
		        headers: { //头部参数
		            frontUserToken: this.getUserToken
		        },
				params:{
					studentId :this.studentId,
					courseId:this.courseId
				 }
		    });
			if(res.code==200)
			{
				this.options=res.data;
				}
			},
		async getdata() {
		    let res = await this.$api.get("/web/teacher/attendClass/sudokuData", {
		        headers: { //头部参数
		            frontUserToken: this.getUserToken
		        },
				params:{
					planId:this.planId,
					courseId:this.courseId,
					// courseId:"1713948557532336128",
					
				 }
		    });
			if(res.code==200)
			{
				if(res.data==null)
				{
					this.suddata={};
				}else{
						this.suddata=res.data;
				}
				
				this.sudnumlist=[
					{
					wordCount:0	
					},
					{
					wordCount:0	
					},
					{
					wordCount:0	
					},
					{
					wordCount:0	
					},
					{
					wordCount:0	
					},
					{
					wordCount:0	
					},
					{
					wordCount:0	
					},
					{
					wordCount:0	
					},
				{
				wordCount:0
				},
				];
				
			var sudokuDetailDataVo=	this.suddata.sudokuDetailDataVos;
			if(sudokuDetailDataVo==null)
			{
				return;
			}
				for(var i=0;i<sudokuDetailDataVo.length;i++)
				{
						// this.sudnumlist[i]=sudokuDetailDataVo[i];
						if(sudokuDetailDataVo[i].reviewLevel==0)
						{
							this.sudnumlist[0]=sudokuDetailDataVo[i];
						}else if(sudokuDetailDataVo[i].reviewLevel==1)
						{
							this.sudnumlist[1]=sudokuDetailDataVo[i];
						}else if(sudokuDetailDataVo[i].reviewLevel==2)
						{
							this.sudnumlist[2]=sudokuDetailDataVo[i];
						}else if(sudokuDetailDataVo[i].reviewLevel==3)
						{
							this.sudnumlist[3]=sudokuDetailDataVo[i];
						}else if(sudokuDetailDataVo[i].reviewLevel==4)
						{
							this.sudnumlist[4]=sudokuDetailDataVo[i];
						}else if(sudokuDetailDataVo[i].reviewLevel==5)
						{
							this.sudnumlist[5]=sudokuDetailDataVo[i];
						}else if(sudokuDetailDataVo[i].reviewLevel==6)
						{
							this.sudnumlist[6]=sudokuDetailDataVo[i];
						}else if(sudokuDetailDataVo[i].reviewLevel==7)
						{
							this.sudnumlist[7]=sudokuDetailDataVo[i];
						}else if(sudokuDetailDataVo[i].reviewLevel==8)
						{
							this.sudnumlist[8]=sudokuDetailDataVo[i];
						}
						
						
						
					// if(sudokuDetailDataVo[i].reviewLevel==0)
					// {
					// 	this.sudnumlist[6]=sudokuDetailDataVo[i];
					// }else if(sudokuDetailDataVo[i].reviewLevel==1)
					// {
					// 	this.sudnumlist[3]=sudokuDetailDataVo[i];
					// }else if(sudokuDetailDataVo[i].reviewLevel==2)
					// {
					// 	this.sudnumlist[0]=sudokuDetailDataVo[i];
					// }else if(sudokuDetailDataVo[i].reviewLevel==3)
					// {
					// 	this.sudnumlist[1]=sudokuDetailDataVo[i];
					// }else if(sudokuDetailDataVo[i].reviewLevel==4)
					// {
					// 	this.sudnumlist[2]=sudokuDetailDataVo[i];
					// }else if(sudokuDetailDataVo[i].reviewLevel==5)
					// {
					// 	this.sudnumlist[5]=sudokuDetailDataVo[i];
					// }else if(sudokuDetailDataVo[i].reviewLevel==6)
					// {
					// 	this.sudnumlist[8]=sudokuDetailDataVo[i];
					// }else if(sudokuDetailDataVo[i].reviewLevel==7)
					// {
					// 	this.sudnumlist[7]=sudokuDetailDataVo[i];
					// }else if(sudokuDetailDataVo[i].reviewLevel==8)
					// {
					// 	this.sudnumlist[4]=sudokuDetailDataVo[i];
					// }
				}
			} 
		},
    }

}
</script>

<style lang="scss" scoped>
.main-box {
    background: #7CDBB8;

    .content-box {
        margin-top: 72px;
        // width: 92.875%;
        width: 739px;
        height: 798px;
        border-radius: 20px;
        background: #E5F3F1;

        .content-box-title {
            text-align: center;
            margin-top: 23px;
            font-family: Source Han Sans CN;
            font-size: 30px;
            font-weight: bold;
            line-height: normal;
            letter-spacing: 0em;

            font-feature-settings: "kern" on;
            /* 333333 */
            color: #333333;
        }

        .content-box-text {
            text-align: center;
            margin-top: 9px;
            font-family: Source Han Sans CN;
            font-size: 18px;
            font-weight: normal;
            line-height: normal;
            letter-spacing: 0em;

            font-feature-settings: "kern" on;
            /* 333333 */
            color: #333333;
        }

        .content-box-list {
            margin-top: 29px;
            padding: 0 11%;
            box-sizing: border-box;

            .content-box-item {
				cursor: pointer;
                margin-bottom: 20px;
                // width: 180px;
                width: 31.135%;
                height: 190px;
                border-radius: 20px;
                flex-shrink: 0;

                background-repeat: no-repeat;
                background-size: 100% 100%;

                div {
                    text-align: center;
                    width: 82px;
                    height: 82px;
                    border-radius: 82px;

                    /* 纯白 */
                    background: #FFFFFF;

                    font-family: Oswald;
                    font-size: 45px;
                    font-weight: normal;
                    line-height: 82px;
                    text-align: center;
                    letter-spacing: 0em;

                    font-feature-settings: "kern" on;
                    color: #2BC3C8;
                    
                    margin-bottom: 11px;
                }
            }
        }

    }

    .content-box2 {
        margin-top: 72px;
        width: 78.125%;
		padding-bottom: 20px;
        border-radius: 20px;
        background: #FFFFFF;

        .content-box2-select {
            margin-top: 20px;
            // width: 210px;
            width: 84%;
            height: 64px;
            border-radius: 10px;
            opacity: 1;

            box-sizing: border-box;
            border: 1px solid rgba(10, 162, 107, 0.2);
            display: flex;
            align-items: center;
        }

        .content-box2-info {
            margin-top: 20px;
            // width: 210px;
            width: 84%;
            min-height: 119px;
            border-radius: 20px;
            box-sizing: border-box;
            padding: 11px 20px 18px 20px;

            background: linear-gradient(340deg, #FFFFFF 13%, #D9F1E5 98%);

            box-shadow: 0px 0px 10px 0px rgba(145, 170, 158, 0.1);

            .content-box2-info-item {
                span {
                    &:first-child {
                        margin-right: 15px;
                        font-family: Source Han Sans CN;
                        font-size: 18px;
                        font-weight: normal;
                        line-height: 30px;
                        letter-spacing: 0em;

                        font-feature-settings: "kern" on;
                        /* 灰 */
                        color: #ACBEB0;
                    }

                    &:last-child {

                        font-family: Oswald;
                        font-size: 18px;
                        font-weight: normal;
                        line-height: 30px;
                        letter-spacing: 0em;

                        font-feature-settings: "kern" on;
                        /* 绿 */
                        color: #0AA26B;
                    }

                }
            }

        }

        .content-box2-info-btn1 {
			 cursor: pointer;
            margin-top: 23px;
            text-align: center;
            // width: 210px;
            width: 84%;
            height: 46px;
            border-radius: 100px;
            /* 绿 */
            background: #0AA26B;
            font-family: Source Han Sans CN;
            font-size: 18px;
            font-weight: bold;
            line-height: 46px;
            letter-spacing: 0em;

            font-feature-settings: "kern" on;
            /* 纯白 */
            color: #FFFFFF;

        }

        .content-box2-info-btn2 {
			 cursor: pointer;
            margin-top: 20px;
            text-align: center;
            // width: 210px;
            width: 84%;
            height: 46px;
            border-radius: 100px;

            background: rgba(10, 162, 107, 0.2);
            font-family: Source Han Sans CN;
            font-size: 18px;
            font-weight: bold;
            line-height: 46px;
            letter-spacing: 0em;

            font-feature-settings: "kern" on;
            /* 绿 */
            color: #0AA26B;
        }

        .content-box2-info-btn3 {
			 cursor: pointer;
            margin-top: 20px;
            text-align: center;
            // width: 210px;
            width: 84%;
            height: 46px;
            border-radius: 100px;

            /* 灰 */
            background: #ACBEB0;
            font-family: Source Han Sans CN;
            font-size: 18px;
            font-weight: bold;
            line-height: 46px;
            text-align: center;
            letter-spacing: 0em;

            font-feature-settings: "kern" on;
            /* 纯白 */
            color: #FFFFFF;
        }

    }

    /deep/ .el-input__inner {
        border: 0;
        font-family: 思源黑体;
        font-size: 18px;
        font-weight: normal;
        line-height: normal;
        letter-spacing: 0em;

        font-feature-settings: "kern" on;
        /* 333333 */
        color: #333333;
    }
	
	
	.appraise-popup-title {
	    width: 100%;
	    height: 86px;
	    border-radius: 20px 20px 0 0;
	    background: #0AA26B;
	    box-sizing: border-box;
	    padding: 0 35px;
	
	    .appraise-popup-title-name {
	        font-family: 思源黑体;
	        font-size: 26px;
	        font-weight: bold;
	        line-height: normal;
	        letter-spacing: 0em;
	
	        font-feature-settings: "kern" on;
	        /* 纯白 */
	        color: #FFFFFF;
	    }
	
	    img {
	        width: 56px;
	        height: 56px;
	    }
	}
	
	.start-popup-content {
	    background: #fff;
	    border-radius: 0 0 20px 20px;
	    box-sizing: border-box;
	    padding: 0 52px;
	
	    .start-popup-content-text1 {
	        margin-left: 173.5px;
	        margin-top: 89px;
	        font-family: 思源黑体;
	        font-size: 22px;
	        font-weight: normal;
	        line-height: 40px;
	        letter-spacing: 0em;
	
	        font-feature-settings: "kern" on;
	        /* 333333 */
	        color: #333333;
	    }
	
	    .start-popup-content-timebox {
	        margin-top: 30px;
	        margin-left: 173.5px;
	
	        span {
	            margin-right: 30px;
	            font-family: 思源黑体;
	            font-size: 22px;
	            font-weight: normal;
	            line-height: 30px;
	            letter-spacing: 0em;
	
	            font-feature-settings: "kern" on;
	            /* 333333 */
	            color: #333333;
	        }
	
	        div {
	            width: 195px;
	            height: 64px;
	            border-radius: 100px;
	            opacity: 1;
	
	            background: #E5F7F1;
	
	            box-sizing: border-box;
	            border: 1px solid rgba(10, 162, 107, 0.2);
	        }
	
	    }
	
	    .start-popup-content-tipsbox {
	        margin-top: 89px;
	        margin-bottom: 75px;
	        font-family: 思源黑体;
	        font-size: 22px;
	        font-weight: normal;
	        line-height: 40px;
	        letter-spacing: 0em;
	
	        font-feature-settings: "kern" on;
	        /* 确认开始学员 */
	        color: #333333
	    }
	
	    .start-popup-content-line {
	        margin-top: 30px;
	        width: 100%;
	        height: 0px;
	        opacity: 1;
	
	        border: 1px solid rgba(10, 162, 107, 0.2);
	    }
	
	    .start-popup-content-btnsbox {
	        margin-top: 31px;
	        margin-bottom: 30px;
	
	        div {
	            &:first-child {
	                margin-right: 20px;
	                width: 230px;
	                height: 64px;
	                border-radius: 100px;
	                /* 灰 */
	                background: #ACBEB0;
	                font-family: 思源黑体;
	                font-size: 28px;
	                font-weight: bold;
	                line-height: 64px;
	                text-align: center;
	                letter-spacing: 0em;
	
	                font-feature-settings: "kern" on;
	                /* 纯白 */
	                color: #FFFFFF;
	            }
	
	            &:last-child {
	
	                width: 230px;
	                height: 64px;
	                border-radius: 100px;
	                /* 绿 */
	                background: #0AA26B;
	
	                font-family: 思源黑体;
	                font-size: 28px;
	                font-weight: bold;
	                line-height: 64px;
	                text-align: center;
	                letter-spacing: 0em;
	
	                font-feature-settings: "kern" on;
	                /* 纯白 */
	                color: #FFFFFF;
	            }
	        }
	    }
	
	}
	
	
	
	
	/deep/ .el-dialog__header {
	    border-radius: 20px 20px 0 0;
	    padding: 0;
	
	}
	
	/deep/ .el-dialog__body {
	    border-radius: 20px;
	    padding: 0;
	}
	
	/deep/ .el-dialog {
	    background: transparent;
	    border-radius: 20px;
	    box-shadow: 0 0px 0px #ccc;
	
	    @media screen and (min-width: 992px) {
	        width: 44.114%;
	    }
	
	    @media screen and (max-width: 991px) and (min-width: 768px) {
	        width: 82.395%;
	    }
	
	    @media screen and (max-width: 767px) {
	        width: 100%;
	    }
	}
}
</style>